import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const router = new Router({
  routes: [{
      path: '/',
      redirect: 'upload'
    },
    // ��ҳ
    {
      path: '/index',
      name: 'index',
      component: () => import('@/views/index/index')
    },
    // ��¼ 
    {
      path: '/login',
      name: 'login',
      component: () => import('@/views/login/index')
    },
    //�ϴ��ļ� 
    {
      path: '/upload',
      name: 'upload',
      component: () => import('@/views/upload/index')
    },
    // ��ʱ����
    {
      path: '/conversion',
      name: 'conversion',
      component: () => import('@/views/conversion/index')
    },
    //��ʷ��¼ 
    {
      path: '/history',
      name: 'history',
      component: () => import('@/views/history/index')
    },
    // ����ʵ�
    {
      path: '/term',
      name: 'term',
      component: () => import('@/views/term/index')
    },
    {
      path: '/term-detail',
      name: 'term-detail',
      component: () => import('@/views/term-detail/index')
    },
    //Ԥ��ģʽ 
    {
      path: '/preview',
      name: 'preview',
      component: () => import('@/views/preview/html')
    },
    //Ԥ��ģʽ 
    {
      path: '/arxiv',
      name: 'arxiv',
      // component: () => import('@/views/arxiv/index')
      component: () => import('@/views/previewArxiv/html')
    },
    {
      path: '/previewArxiv',
      name: 'previewArxiv',
      component: () => import('@/views/previewArxiv/html')
    },
    {
      path: '/demo',
      name: 'demo',
      component: () => import('@/views/demo/html')
    },

    //Ԥ��ģʽ 
    {
      path: '/preview_pic',
      name: 'preview_pic',
      component: () => import('@/views/preview/index')
    },
    //���߷��� 
    {
      path: '/filePreview',
      name: 'filePreview',
      component: () => import('@/views/filePreview/index')
    },
    //�������� 
    {
      path: '/about',
      name: 'about',
      component: () => import('@/views/about/index')
    },
    // ���� 
    {
      path: '/help',
      name: 'help',
      component: () => import('@/views/help/index')
    },
    // ������ά��ҳ�� 
    {
      path: '/maintain',
      name: 'maintain',
      component: () => import('@/views/maintain/index')
    },
    // ���˿ռ�ҳ��
    {

      path: '/personal',
      name: 'personal',
      component: () => import('@/views/personal/index')
    },
    {

      path: '/setUp',
      name: 'setUp',
      component: () => import('@/views/setUp/index')
    },
    // ����ҳ��
    {
      path: '/text',
      name: 'text',
      component: () => import('@/views/preview/text')
    },
    // �����Ĳ���ҳ��
    {
      path: '/splitScreen',
      name: 'splitScreen',
      component: () => import('@/views/preview/splitScreen')
    },
    // �����Ĳ���ҳ��
    {
      path: '/splitScreen2',
      name: 'splitScreen2',
      component: () => import('@/views/preview/splitScreen2')
    },
    // �����Ĳ���ҳ��
    {
      path: '/splitScreen3',
      name: 'splitScreen3',
      component: () => import('@/views/preview/splitScreen3')
    },
    // ������ת����ҳ
    {
      path: '/transition',
      name: 'transition',
      component: () => import('@/views/transition/index')
    },
    //404ҳ��
    {
      path: '*',
      name: '404',
      component: () => import('@/views/404/index')
    }
  ]
})
router.beforeEach((to, from, next) => {
  //   
  console.log(to.path)
  if (to.path == '/demo' || to.path == '/arxiv' || to.path == '/previewArxiv') {
    next()
  } else if (to.path !== '/login' && to.path !== '/transition' && !JSON.parse(window.localStorage.getItem("usid"))) {
    // �û�δ��¼��ת����¼ҳ��
    return next('/login')
  } else {
    next()

  }
})

router.afterEach((to, from, next) => {
  window.scrollTo(0, 0);
});

export default router



// WEBPACK FOOTER //
// ./src/router/index.js